const Title = [
  "Time of Specimen",
  "Time of Examination",
  "Duration of Abstinence",
  "Liquefication at 37 oC",
  "Volume",
  "Appearance",
  "Color",
  "Viscosity",
  "pH",
];

export default Title;
